import { CoroutineScopeHelpers1j3li0lv9e54a as CoroutineScopeHelpers } from '../../../../../reactive/com/lightningkite/reactive/context/CoroutineScopeHelpers.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function invoke(_this__u8e3s4) {
  return _this__u8e3s4.startAction_u0zgbm_k$(this);
}
var KiteUiCoroutineScopeHelpersClass;
function KiteUiCoroutineScopeHelpers() {
  if (KiteUiCoroutineScopeHelpersClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'KiteUiCoroutineScopeHelpers', VOID, VOID, [CoroutineScopeHelpers()]);
    KiteUiCoroutineScopeHelpersClass = $;
  }
  return KiteUiCoroutineScopeHelpersClass;
}
//region block: exports
export {
  invoke as invoke3srivg5vay2ub,
  KiteUiCoroutineScopeHelpers as KiteUiCoroutineScopeHelpers25rj47zs39igb,
};
//endregion

//# sourceMappingURL=KiteUiCoroutineScopeHelpers.mjs.map
